<template>
    <section style="margin: 18px;">
        <v-btn @click="OpenDialog">Add Webinar</v-btn>
        <app-add-webinar ref='UpdateWebinarTopic' :dialog='dialog' @close='CloseDialog'></app-add-webinar>
        <v-data-table :headers="headers" :items="GetWebinars" hide-actions
                      disable-initial-sort item-key="Webinar_Title" class="elevation-1" style="margin-top: 18px;margin-bottom: 18px;">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
                </tr>
            </template>
            <template v-slot:items="props">
            <tr>
                <td class="text-xs-center">{{ props.item.Webinar_Title }}</td>
                <td class="text-xs-center" v-html="props.item.Webinar_Description"></td>
                <td class="text-xs-center">{{ new Date(props.item.Webinar_Date_Time).toLocaleDateString() }} , {{ new Date(props.item.Webinar_Date_Time).toLocaleTimeString() }}</td>
                <td class="text-xs-center">{{ props.item.Webinar_Type == 'Webinar_Form' ? 'Form' : 'Link' }}</td>
                <td class="text-xs-center">
                    <v-btn color="primary" icon class="btnAction" @click="OpenUpdateModal(props.item)">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn color="error" icon class="btnAction" @click="DeleteWebinar(props.item)">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </tr>
            </template>
      </v-data-table>
      <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
    </section>
</template>
<script>
import appAddWebinar from '../views/dialogs/AddWebinar'

export default {
    components:{
        appAddWebinar
    },
    data(){
        return {
            dialog  : false,
            headers : [
                        { text: "Webinar Title", value: "Webinar_Title" },
                        { text: "Webinar Description", value: "Webinar_Description" },
                        { text: "Webinar Date/Time", value: "Webinar_Date_Time" },
                        { text: "Webinar Type", value: "Webinar_Type" },
                        { text: "Actions" }
                      ],
            pages                       : 1,
            records                     : 0,
        }
    },
    computed:{
         GetWebinars(){
             return this.$store.getters.GetWebinarList
         }
    },
    methods:{
        OpenDialog(){
            this.dialog = true
        },
        CloseDialog(){
            this.dialog = false
        },
        OpenUpdateModal(Item){
           
            this.$refs.UpdateWebinarTopic.OpenUpdate(Item)
            this.OpenDialog()
        },  
        DeleteWebinar(Item){
            if (confirm("Do you really want to delete?")) {

                this.$http.post(`${this.$store.getters.GetProductionUrl}/webinar/deletewebinar`,Item)
                            .then(response =>{
                                
                                this.$store.commit("DeleteIndividualWebinar",response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Webinar","Color":"green","Close": false });
                            })
                            .catch(err =>{
        
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Webinar","Color":"red","Close": false });
                            })
            }
        },
        GetNextSetOfData(){

            let data = { limit:10, page : this.pages }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/webinar/getwebinarlist`,data)
                        .then(response =>{

                                this.records = response['data']['Records']
                                this.$store.commit("SetWebinarList",response['data']['response'])
                                this.$eventHub.$emit("LOADING",'false')
                        })
                        .catch(err =>{
    
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Webinar","Color":"red","Close": false });
                        })
        }
    },
    mounted(){
        this.GetNextSetOfData()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>